import './styles.css';

export function ProblemSolution() {
  return (
    <section id="features" className="section sectionAlt">
      <div className="container">
        <div className="sectionHead">
          <h2>
            Break out of the <span className="accent">campus bubble</span>
          </h2>
          <p className="muted">Traditional education limits your network to your physical location. We’re changing that.</p>
        </div>

        <div className="twoUp">
          <div className="panel">
            <div className="panelBadge warning">The Problem</div>
            <h3>Students collaborate only within their faculty and country.</h3>
            <ul className="list">
              <li>Developers work only with developers</li>
              <li>Designers rarely collaborate with engineers</li>
              <li>Limited international exposure during studies</li>
              <li>Mobility programs reach a small minority</li>
            </ul>
          </div>

          <div className="panel panelDark">
            <div className="panelBadge success">Solution</div>
            <h3>One workspace for interdisciplinary, international teamwork.</h3>
            <ul className="list listChecks">
              <li>Match across disciplines, universities and countries</li>
              <li>Run academic projects, hackathons and startups</li>
              <li>Built-in tasks, files and mentor oversight</li>
              <li>Credit and CV-ready collaboration history</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

